import React, { Component } from 'react';
import { NavLink,withRouter } from "react-router-dom";
import Global from '../globals/global';
import Tours from './page.tours';
import CustomTours from "../components/component.tours.list";
import moment from 'moment';
const $ = window.$;

class Group extends Global{

    constructor(props) {
    super(props);

   // this.config().groupinfo = {"Id_PartnerGroup":"136","GroupNumber":"","Name":"Charly & Kim Wedding","Description":"Personalized phrase 1 asdfasd","Description_2":"love, love, love asdfasd fsdfsa","Destination":"Puerto Vallarta","Id_Destination":"2","Id_Location":null,"SpecialOffer":"","ActivityDate":"March 31","CouponCode":"","Id_Agency":"62","Id_Agent":"123","CRC32":"7baeb76f","ImageFileName":"","EnableTransfers":"0","isActive":"-1","MoreInfo":"&lt;p&gt;&amp;nbsp;&lt;\/p&gt;\n&lt;p&gt;If any question, contact your vacation concierge.&lt;\/p&gt;\n&lt;p&gt;Click on chat button to &lt;strong&gt;CHAT&lt;\/strong&gt;&lt;\/p&gt;\n&lt;p&gt;&lt;strong&gt;telephone number...&lt;\/strong&gt;&lt;\/p&gt;\n&lt;p&gt;&lt;span style=&quot;color: #ff0000;&quot;&gt;extra information&lt;\/span&gt;&lt;\/p&gt;","MoreInfo_Fra":"&lt;p&gt;&amp;nbsp;&lt;\/p&gt;\n&lt;p&gt;test 2&lt;\/p&gt;","ExpirationDate":null,"UrlName":"5bc1c797-1c33-11ea-a39b-002590792f54","Footer":"\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cp class=\"text_group_bott\"\u003EThis special site is just for YOU -- complete with our own destination concierge who can assist with answering your questions, making plans and booking activities --\u003Cb class=\"blue_color_g\"\u003E EXPERIENCED LOCAL PROFESSIONALS YOU CAN COUNT ON\u003C\/b\u003E\u003Cbr\u003E \u003Cbr\u003ETop Quality, Service and Great Prices so \u003Cb class=\"phone_traficag\"\u003EYOU GET THE BEST EXPERIENCES POSSIBLE.\u003C\/b\u003E\u003Cbr\u003E \u003Cbr\u003E\u003Cspan\u003EFOR ASSISTANCE\u003C\/span\u003E \u003Cbr\u003E with our Concierge 9:00am to 6:00pm Local Time Daily. \u003Cbr\u003E\u003Cbr\u003E\u003Cb\u003E CALL TOLL FREE BEFORE YOUR ARRIVE\u003C\/b\u003E, 1-855-847-5333 \u003Cbr\u003EOR OUR LOCAL OFFICE DURING YOUR STAY: (998) 193 0573\u003C\/p\u003E\u003C\/div\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cimg src=\"https:\/\/cdn.mobilesail.com\/static_demos\/trafictours\/img\/family_t1.png\" class=\"img-fluid\"\u003E\u003C\/div\u003E\u003C\/div\u003E","Created":"2012-01-01 00:00:00","Modified":"2017-09-08 09:15:55","SortPosition":"0","CustomServicePhoneNum":"(322) 226 0300","result":true,"tours":[{"Country":"Mexico","TourStatus":"Active","Id_Status":"1","Id":"196","UserRating":"4.0000","hasTransportationIncluded":"-1","isThreeXTwo":"0","Name":"See Vallarta City Tour (with Lunch)","UrlName":"see-vallarta-tour-(lunch-incl)-196","Popular":"1","Id_Destination":"2","DestinationName":"Puerto Vallarta & Riviera Nayarit","LongDescription":"A tour you will love! We'll visit the Boardwalk with its emblematic monuments and the iconic Church of Guadalupe. Later, we'll shop at the Municipal Market and some of the best stores with Mexican handcrafts and jewelry. Afterwards we'll head out to Mismaloya with a brief stop at Los Arcos, the place that gave the original name to our port. Our lunch stop will be at El Patio, famous for its \"seafood platter\" and of course the tour will not end until you have seen the process that makes our national elixir, tequila, at the distillery gallery. Our experienced guides will show you the best of this Pacific Jewel! INCLUDES: Round trip transportation service from most hotels (varies for Riviera Nayarit) - Certified tour guide - Walking tour at Vallarta downtown - Visit to jewelry shop - Free Shopping time- Tequila Distillery tour - Mexican Food - Tequila tasting. *Itinerary may vary. ***$7 USD Transfer charge for Iberostar and Palladium hotels.","bFixedCurrencyPrice":"0","ShortDescription":"The best way to get to know the destination.","Id_Location":"26","LocationName":"Puerto Vallarta, Riviera Nayarit","hDuration":"6","mDuration":"0","DurationInMinutes":"360.0000","OfferAvailable":"0","Id_Offer":null,"RwdAvailable":"0","GpsLocationLat":"20.612049","GpsLocationLong":"-105.234314","isTopRated":"0","hasTrend":"0","CRC32":"8","CurrencyCode":"USD","hasExclusiveSBIRates":"0","Price":"64.00","NormalPrice":"64.00","TypeName":"Land, Cultural, Family, Shopping","TypeNameEng":"Land, Cultural, Family, Shopping","InWishlist":0}],"image":"https:\/\/admin-tagentpro.mobilesail.com\/images\/agencies_logos\/G136.png?v=7baeb76f","total_tours":1,"tourids":"196","sql_tours":"SELECT SQL_CALC_FOUND_ROWS GeoPaises.Name AS Country, SysToursStatusDef.Name As TourStatus, SysTours.Id_Status, SysTours.Id_Tour AS Id, SysTours.UserRating, SysTours.hasTransportationIncluded, SysTours.isThreeXTwo, SysTours.Name AS Name, SysTours.UrlName, MIN(SysToursTypes.Id_Type) AS Popular, SysTours.Id_Destination, SysDestinations.Name AS DestinationName, SysTours.LongDescription AS LongDescription, SysTours.bFixedCurrencyPrice, SysTours.ShortDescription AS ShortDescription, SysToursLocations.Id_Location, (SELECT \r\n                                 GROUP_CONCAT(slocations.Name ORDER BY slocations.Name SEPARATOR ', ')\r\n                                 FROM SysLocations slocations \r\n                                 LEFT JOIN SysToursLocations stourslocations ON stourslocations.Id_Location = slocations.Id_Location\r\n                                 WHERE slocations.Id_Destination = 2 AND stourslocations.Id_Tour = SysTours.Id_Tour) AS LocationName,\r\n                                  HOUR( Duration) AS hDuration, MINUTE( Duration) AS mDuration,  (TIME_TO_SEC(Duration)\/60) AS DurationInMinutes, IF(o.Id_TourOffer != '' AND (curdate() BETWEEN o.StartDate AND o.EndDate),OfferAvailable,0) AS OfferAvailable, Id_Offer, SysTours.RwdAvailable, SysTours.GpsLocationLat, SysTours.GpsLocationLong, isTopRated, hasTrend, SysTours.CRC32, 'USD' AS CurrencyCode, SysTours.hasExclusiveSBIRates, IF(SysTours.bFixedCurrencyPrice = -1,IF(s.Id_TourPriceTypeDef = 3,  CONVERT(COALESCE( o.OnePasengersPrice,o.TwoPasengersPrice,o.ThreePasengersPrice,o.FourPasengersPrice,  fs.OnePasengersPrice, fs.TwoPasengersPrice, fs.ThreePasengersPrice, fs.FourPasengersPrice, s.OnePasengersPrice, s.TwoPasengersPrice, s.ThreePasengersPrice, s.FourPasengersPrice, -1),DECIMAL(8,2)), IF(s.Id_TourPriceTypeDef = 2, CONVERT(COALESCE(   o.GroupPrice, fs.GroupPrice, s.GroupPrice, -1),DECIMAL(8,2)), CONVERT(COALESCE( o.AdultPrice, fs.AdultPrice, s.AdultPrice, -1), DECIMAL(8,2)))), IF(s.Id_TourPriceTypeDef = 3,  CONVERT(COALESCE( o.OnePasengersPrice,o.TwoPasengersPrice,o.ThreePasengersPrice,o.FourPasengersPrice,  fs.OnePasengersPrice, fs.TwoPasengersPrice, fs.ThreePasengersPrice, fs.FourPasengersPrice, s.OnePasengersPrice, s.TwoPasengersPrice, s.ThreePasengersPrice, s.FourPasengersPrice, -1),DECIMAL(8,2)), IF(s.Id_TourPriceTypeDef = 2, CONVERT(COALESCE(   o.GroupPrice, fs.GroupPrice, s.GroupPrice, -1),DECIMAL(8,2)), CONVERT(COALESCE( o.AdultPrice, fs.AdultPrice, s.AdultPrice, -1), DECIMAL(8,2))))) AS Price, IF(SysTours.bFixedCurrencyPrice = -1,IF(s.Id_TourPriceTypeDef = 3, CONVERT(COALESCE( fs.OnePasengersPrice, fs.TwoPasengersPrice, fs.ThreePasengersPrice, fs.FourPasengersPrice,s.OnePasengersPrice, s.TwoPasengersPrice, s.ThreePasengersPrice, s.FourPasengersPrice, -1),DECIMAL(8,2)), IF(s.Id_TourPriceTypeDef = 2, CONVERT(COALESCE( fs.GroupPrice,s.GroupPrice, -1),DECIMAL(8,2)), CONVERT(COALESCE( fs.AdultPrice,s.AdultPrice, -1),DECIMAL(8,2)))), IF(s.Id_TourPriceTypeDef = 3, CONVERT(COALESCE( fs.OnePasengersPrice, fs.TwoPasengersPrice, fs.ThreePasengersPrice, fs.FourPasengersPrice,s.OnePasengersPrice, s.TwoPasengersPrice, s.ThreePasengersPrice, s.FourPasengersPrice, -1),DECIMAL(8,2)), IF(s.Id_TourPriceTypeDef = 2, CONVERT(COALESCE( fs.GroupPrice,s.GroupPrice, -1),DECIMAL(8,2)), CONVERT(COALESCE( fs.AdultPrice,s.AdultPrice, -1),DECIMAL(8,2))))) AS NormalPrice,(SELECT GROUP_CONCAT(sttd.Name ORDER BY sttd.Id_Type SEPARATOR ', ') FROM SysToursTypes stt INNER JOIN SysToursTypesDef sttd ON stt.Id_Type=sttd.Id_Type WHERE stt.Id_Tour=SysTours.Id_Tour AND stt.Id_Type\u003C\u003E1 GROUP BY stt.Id_Tour) as TypeName, (SELECT GROUP_CONCAT(sttd.Name ORDER BY sttd.Id_Type SEPARATOR ', ') FROM SysToursTypes stt INNER JOIN SysToursTypesDef sttd ON stt.Id_Type=sttd.Id_Type WHERE stt.Id_Tour=SysTours.Id_Tour AND stt.Id_Type\u003C\u003E1 GROUP BY stt.Id_Tour) as TypeNameEng FROM SysTours INNER JOIN SysToursTypes ON SysToursTypes.Id_Tour = SysTours.Id_Tour INNER JOIN SysToursTypesDef ON SysToursTypesDef.Id_Type = SysToursTypes.Id_Type LEFT JOIN SysDestinations ON SysDestinations.Id_Destination = SysTours.Id_Destination LEFT JOIN GeoPaises ON GeoPaises.Id_Country = SysDestinations.Id_Country LEFT JOIN SysToursSeason s ON (s.Id_Tour = SysTours.Id_Tour) AND ((curdate() BETWEEN curdate() AND s.StartDate) OR (curdate() BETWEEN s.EndDate AND curdate()) OR (s.StartDate is null AND s.EndDate is null)) AND s.Id_ActivityRate = 1 AND s.isExclusiveSBIRates = 0  LEFT JOIN SysToursOffers o ON (o.Id_Tour = SysTours.Id_Tour) AND (curdate() BETWEEN o.StartDate AND o.EndDate)  AND o.Id_ActivityRate = 1  LEFT JOIN SysToursHotels ON SysToursHotels.Id_Tour = SysTours.Id_Tour LEFT JOIN SysToursSeason fs ON (fs.Id_Tour = SysTours.Id_Tour) AND ((curdate() BETWEEN fs.StartDate AND fs.EndDate)) AND fs.Id_ActivityRate = 1 AND fs.isExclusiveSBIRates = 0 LEFT JOIN SysToursStatusDef ON SysToursStatusDef.Id_TourStatus = SysTours.Id_Status LEFT JOIN SysProviders ON SysProviders.Id_Provider = SysTours.Id_Provider LEFT JOIN SysToursLocations ON SysToursLocations.Id_Tour = SysTours.Id_Tour LEFT JOIN SysLocations ON SysLocations.Id_Location = SysToursLocations.Id_Location WHERE (SysTours.Id_Status IN (1, 2, 3)   AND SysTours.isDeleted = 0 AND SysTours.Name != ''  AND (SysTours.ShortDescription != '' AND SysTours.LongDescription != '')  AND SysTours.Id_Tour IN(SELECT Id_Tour FROM SysToursSBI WHERE Id_SBI = -1 AND Enabled = -1 GROUP BY Id_Tour ORDER BY Id_Tour)   AND SysTours.Id_Tour IN (196)    AND SysTours.Id_Destination IN (2)         )  GROUP BY SysTours.Id_Tour  ORDER BY isTopRated ASC, SysTours.SortPosition ASC, SysTours.SortPosition ASC   ","_SessionLang":"","_Id_Currency":1,"isFromCache":false};
    this.state ={
       groupinfo:this.config().groupinfo
      }

  }

    componentDidMount(){

        $('header').addClass('tour_bg');

        $('.openchat').off('click').on('click',function(){
            this.openchat()
        }.bind(this))

        var group = this.state.groupinfo;
        if(group){
          if(group.ExpirationDate != ''){
            if(moment(group.ExpirationDate) < moment()) this.preventpopup();
          }
        }
    }

    componentWillMount(){

      
    }

    componentWillUnmount() {
        $('header').removeClass('tour_bg');
    }


    htmlDecode(value){
   /* var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;*/
    return $('<textarea />').html(value).text();
   }

   preventpopup(){
   

    $.magnificPopup.open({
      items: {
        src: "#preventp"
      },
      type: 'inline',
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: 'auto',
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      closeOnBgClick:false,
      closeBtnInside:true,
      mainClass: 'my-mfp-zoom-in',
      callbacks: {
        open: function() {



        }.bind(this),

        close: function() {

        }.bind(this)
      }
    });

  
   }


    render() {

       if(!this.state.groupinfo) return null;

       var group = this.state.groupinfo;
       
       var phone = '1-855-847-5333';

       var MoreInfo = group.MoreInfo;
       var Footer = group.Footer;

       if(Number(this.getglobaldata('Id_Language')) == 2) {

        MoreInfo = group.MoreInfo_Esp == ''?group.MoreInfo:group.MoreInfo_Esp;
        Footer = group.Footer_Esp == ''?group.Footer:group.Footer_Esp;

       }else if(Number(this.getglobaldata('Id_Language')) == 3) {

        MoreInfo = group.MoreInfo_Fra == ''?group.MoreInfo:group.MoreInfo_Fra;
        Footer = group.Footer_Fra == ''?group.Footer:group.Footer_Fra;

       }

       if(MoreInfo) MoreInfo = this.htmlDecode(MoreInfo);
       if(Footer) Footer = this.htmlDecode(Footer);

       var groupclass = 'grouppage'+'-'+group.UrlName;

        return (
            <div>
            
            <section>
            <div className="container">
                <div className="group_ac_content">
                </div>
            </div>
         </section>


             <main>
        <div className={"container grouppage "+groupclass}>
          <div className="row">
            <div className="col-lg-12">
              <div className="m-t-30" />
              {/* Nav tabs */}
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a className="nav-link active border_l border_ho" data-toggle="tab" href="#menu1">{this.t('Information')}</a>
                </li>
              </ul>
              {/* Tab panes */}
              <div className="tab-content back_dream_a">
                <div id="menu1" className="container tab-pane active">
                
                {group.isCustomHTML == 0  ?
                  <div className="row">
                    <div className="col-lg-7">
                      <img src={group.image} className="img-fluid" />
                    </div>
                    <div className="col-lg-5">
                      <h1 className="title_group_ac">{group.Name}</h1>
                      <p className="text_d_group_ac">{group.Destination}</p>
                       <p className="text_d_group_ac_b">{group.ActivityDate}</p>
                      

                      <br /><br />

                      
                       <div dangerouslySetInnerHTML={{ __html: MoreInfo}}></div>
                

                    </div>
                  </div>:
                  <div dangerouslySetInnerHTML={{ __html: MoreInfo}}></div>
                }
                </div>{/*end menu1*/}
              </div>{/*end tab-content*/}
            </div>{/*end col-12*/}


           {group.total_tours > 0 ?
            <div className="col-lg-12">
            <CustomTours tours={group.tours} />
            </div>
            :
            <Tours match={false}/>
           }

            <div className="col-lg-12">
              <div className="card">

              <div className="card-body bor_t" dangerouslySetInnerHTML={{ __html:Footer}}></div>


              {/*  
                <div className="card-body bor_t">
                  <div className="row">
                    <div className="col-md-6">
                      <p className="text_group_bott" dangerouslySetInnerHTML={{ __html:this.t('This special site is just for YOU -- complete with our own destination concierge who can assist with answering your questions, making plans and booking activities --<b className="blue_color_g"> EXPERIENCED LOCAL PROFESSIONALS YOU CAN COUNT ON</b><br /> <br />Top Quality, Service and Great Prices so <b className="phone_traficag">YOU GET THE BEST EXPERIENCES POSSIBLE.</b><br /> <br /><span>FOR ASSISTANCE</span> <br /> with our Concierge 9:00am to 6:00pm Local Time Daily. <br /><br /><b> CALL TOLL FREE BEFORE YOUR ARRIVE</b>, {{phone}} <br />',{phone:phone})}} ></p>
                       
                       <p className="text_group_bott">
                       {group.CustomServicePhoneNum != ''?<p> <b>{this.t('OR OUR LOCAL OFFICE DURING YOUR STAY:')}</b> {group.CustomServicePhoneNum}</p>:''}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <img src="https://cdn.mobilesail.com/static_demos/trafictours/img/family_t1.png" className="img-fluid" />
                    </div>
                  </div>
                </div>
              */}

              </div>
            </div>
          </div>
          {/*End row */}
        </div>
        {/*End container */}
        <div id="overlay" />
        {/* Mask on input focus */}
      </main>

      <div>
  {/* Prevent Popup */}
  <div id="preventp" className="zoom-anim-dialog mfp-hide">
    <div className="small-dialog-header"></div>
    <div className="sign-in-wrapper text-center">
      <div className="tour_container">
        <div className="tour_title">
          <h3 className="blue_color_g">
            <strong>
              {this.t('Online Bookings for')} {group.Name} <br />
              - {group.Destination} - {group.ActivityDate}, <br />
              {this.t('are not longer available.')}
            </strong>
          </h3>
          <br />
          <span className="text-justify">
            <strong dangerouslySetInnerHTML={{ __html: this.t('Please contact your local host/representative at the hotel to book <br /> additional excursions.')}}></strong>
          </span>
        </div>
      </div>
    </div>
  </div>

</div>



      </div>
        )
    }

}

export default Group